import axios from "axios";

export const fetchCreateJobTitle = async (data: any) => {
    return await axios.post("/api/company/job", data);
};
